// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"761d8e15","505":"c085dea3","721":"232a1d8f","899":"1ed3e10e"}[chunkId] + ".chunk.js";
};